import React from "react";
import bodyHelperTypes from "../../../utils/BodyHelperTypes";
import Links from "../../../components/Links";

const iM_Content = [

    {
        format: bodyHelperTypes.paragraphs,
        order: 20,
        content: [
            <><Links linkTypeID="774" /></>
        ]
    },
];

export default iM_Content;

